module.exports = __webpack_public_path__ + "assets/assets/images/icons/Default_image.4933323e.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/icons/Default_image.png
// module id = 524
// module chunks = 0